export default __webpack_public_path__ + "images/check.9d81d365ec3fb672a321dd8f07672300.svg";